export default class ProcessJob {
  id = null;
  process = null;
  processName = null;
  facility = null;
  facilityName = null;

  date = null;

  documentations = [];

  assignedTo = null;
  assignedToName = null;
  assignedToRole = null;
  assignedToRoleName = null;
  accepted = false;
  rejectedByUsers = [];
  rejectedByUsersNames = [];
  finished = false;
  result = null;
  lastResult = false;

  excludedSteps = [];

  generateReport = false;

  generatedSignedReport = null;

  errorReportGenerated = false;

  originalDocumentIdReport = null;

  documentPathReport = null;

  requiresSignature = false;
  requiresRideCount = false;
  requiresFileNumber = false;

  disableDeadline = false;

  constructor() {
  }
}
